import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import { Button } from '@mui/material';
import { ReactNode } from 'react';

interface ControlButtonsProps {
  goToPrev: () => void;
  goToNext: () => void;
  children: ReactNode;
  shouldApply?: boolean;
}

function ControlButtons({
  goToNext,
  goToPrev,
  children,
  shouldApply,
}: ControlButtonsProps) {
  return (
    <>
      {shouldApply && (
        <Button
          id="btn-prev"
          startIcon={(
            <KeyboardArrowLeft
              className="btn-prev"
              style={{
                fontSize: '7rem',
                color: 'rgba(255, 255, 255, 0.5)',
              }}
            />
          )}
          type="button"
          onClick={() => goToPrev()}
          className="btn-prev"
        />
      )}

      {children}

      {shouldApply && (
        <Button
          id="btn-next"
          className="btn-next"
          startIcon={(
            <KeyboardArrowRight
              className="btn-next"
              style={{
                fontSize: '7rem',
                color: 'rgba(255, 255, 255, 0.5)',
              }}
            />
          )}
          type="button"
          onClick={() => goToNext()}
        />
      )}
    </>
  );
}

export default ControlButtons;
